// The clickable questions under "Find out more about NorthStar".
//
// EDIT THIS LIST to add, remove or reword a question - it is the single source
// of truth. The page renders these rows at load, and the build precomputes an
// answer for each one so a click is instant.
//
// Two things follow from that:
//
//  - A new question has no precomputed answer until the next deploy. Until
//    then it still works, it just goes to the live API and takes ~28s.
//  - Rewording a question invalidates its cached answer, because the cache is
//    keyed on the question text. The old entry is simply never looked up
//    again, and the new wording is precomputed on the next build.
//
// Keep them short and specific: the answer quality depends on the question,
// and vague questions produce long, slow, unfocused answers.
export const PREDEFINED_QUESTIONS = [
  'What is the purpose of the NorthStar 5G innovation environment?',
  'What are the functions provided by the NorthStar 5G innovation environment?',
  'What verticals can benefit from NorthStar and 5G SA?',
  'What are some real-world use cases enabled by NorthStar?',
  'What is a network slice?',
  'How does network slicing work in practice together with RRPs, DNNs and 5QIs?',
  'What network slices does NorthStar use?',
  'What 5QIs are there in the standard?',
  'Are separate network slices needed for separating traffic flows or can DNNs be used instead?',
  'How can companies join or collaborate with NorthStar?',
];
